import axios from 'axios'
import QS from 'qs';
import {ElMessage} from 'element-plus'
const { confEnv } = require('../../config')
const service = axios.create({
    // 公共接口--这里注意后面会讲
    baseURL: '/api',  // process.env.NODE_ENV === 'development' ?  '/gateway/usaservice' : confEnv.baseURL + '/gateway/usaservice' http://10.0.110.202:32726/gateway/ukservice/,
    // 超时时间 单位是ms，这里设置了3s的超时时间
    timeout: 120000
})
const statusCode = (status, message) => {
const options = {
    400: '错误请求',
    401:'未授权，请重新登录',
    403: '拒绝访问',
    404: '请求错误,未找到该资源',
    405:'请求方法未允许',
    408: '请求超时',
    500:'服务器端出错',
    501:'网络未实现',
    502:'网络错误',
    503:'服务不可用',
    504:'网络超时',
    505:'http版本不支持该请求',
   }
   if(options[status]) {
        return message || options[status]
   }
   return message || `连接错误${status}`
}

service.interceptors.request.use(config => {
    // showLoading();
    //发请求前做的一些处理，数据转化，配置请求头，设置token,设置loading等，根据需求去添加
    // if(config.method === 'post') {
    //     config.data = QS.stringify(config.data); //数据转化,也可以使用qs转换
    // }

    config.headers = {
        'Content-Type': 'application/json' //配置请求头
    }
    //如有需要：注意使用token的时候需要引入cookie方法或者用本地localStorage等方法，推荐js-cookie
    //const token = getCookie('名称');//这里取token之前，你肯定需要先拿到token,存一下
    //if(token){
    //config.params = {'token':token} //如果要求携带在参数中
    //config.headers.token= token; //如果要求携带在请求头中
    //}
    return config
}, error => {
   return Promise.reject(error)
})


// 3.响应拦截器
service.interceptors.response.use(response => {
    //接收到响应数据并成功后的一些共有的处理，关闭loading等
//    setTimeout(() => {
//        hideLoading()
//    }, 200)

   return response
}, error => {
  
    if(error && error.response) {
       // error.message = statusCode(error.response?.status || 000)
       
    } else {
        if(JSON.stringify(error).includes('timeout')) {
            error.message ='服务器响应超时，请刷新当前页'
          
        } else {
            error.message = '连接服务器失败'
        }
    }
    ElMessage.error(error.message);
   if(error && error.response) {
     return Promise.reject(error.response)
   }
   return Promise.reject(error)
})


export default service